/**
 * 聯絡我們
 * Created at 2021-10-02 15:54
 * @author teapot
 * 22.2778356,114.1719395
 */
import './index.css';
import { useTranslation } from 'react-i18next';

import address from '../../../components/foot/images/address.png';
import phone from '../../../components/foot/images/phone.png';
import fax from '../../../components/foot/images/fax.png';
import email from '../../../components/foot/images/email.png';
import GoogleMaps from './GoogleMaps';
import { Image } from 'antd';
import title from './image/contact.png';
import titleCN from './image/contact-cn.png';
import { locals } from '../../../i18n';
import ContactAddress from './ContactAddress';
const Contact = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className='contact contact-pc'>
        <ContactAddress></ContactAddress>
        {/* <div className="line"></div> */}
        <div className='contact-center'>
          <div className='contact-placeholder' style={{ marginLeft: '25px' }}>
            <GoogleMaps />
          </div>
          <div className='contact-left-item contact-item-left'>
            <Image
            style={{marginBottom:'40px'}}
              src={locals() === 'zh-CN' ? titleCN : title}
              // width={'250px'}
              // height={'60px'} 
              preview={false}
              className='title-bottom'
            />
            <span>
              <img src={address} alt='1' />
              {t('footer_contact_address')}
            </span>
            <span>
              <img src={phone} alt='' />
              {t('footer_contact_phone')}
            </span>
            <span>
              <img src={fax} alt='' />
              {t('footer_contact_fax')}
            </span>
            <span>
              <img src={email} alt='' />
              {t('footer_contact_email')}
            </span>
          </div>
        </div>
      </div>

      <div className='contact contact-phone'>
        <div className='adviser-title adviser-title-size'>
          {t('footer_contact_us')}
        </div>

        <GoogleMaps />

        <div className='contact-left-item contact-item-top'>
          <Image
            src={locals() === 'zh-CN' ? titleCN : title}
            width={'50%'}
            preview={false}
            className='title-bottom'
          />

          <span>
            <img src={address} alt='1' />
            {t('footer_contact_address')}
          </span>
          <span>
            <img src={phone} alt='' />
            {t('footer_contact_phone')}
          </span>
          <span>
            <img src={fax} alt='' />
            {t('footer_contact_fax')}
          </span>
          <span>
            <img src={email} alt='' />
            {t('footer_contact_email')}
          </span>
        </div>
      </div>
    </>
  );
};

export default Contact;
